import {classes} from '@bitstillery/common/lib/utils'
import {Icon, Slider} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import {clear_filter} from '@bitstillery/common/lib/filters'
import {$t} from '@bitstillery/common/app'
import {is_filter_activated} from '@bitstillery/common/lib/filters'
import m from '@bitstillery/mithril'
import type {FilterSelectRangeState} from '@bitstillery/common/types/filters'
import type {Signal} from '@bitstillery/mithril'
export interface FilterSelectRangeAttrs {
    className?: string
    filter: FilterSelectRangeState
    help?: string
    icon?: string
}

/** The base filter state types `$selection` loosely; a range filter's holds its bounds. */
function is_bounds_signal(signal: Signal<unknown> | undefined): signal is Signal<number[]> {
    return signal !== undefined && Array.isArray(signal.value) && signal.value.every((bound) => typeof bound === 'number')
}

export class FilterSelectRange extends MithrilComponent<FilterSelectRangeAttrs> {
    view(vnode: m.Vnode<FilterSelectRangeAttrs>) {
        const active = is_filter_activated(vnode.attrs.filter)

        return (
            <div
                className={classes('c-filter-select-range', 'filter', vnode.attrs.className, {
                    active,
                    collapsed: vnode.attrs.filter.collapsed || vnode.attrs.filter.disabled,
                    disabled: vnode.attrs.filter.disabled,
                })}
            >
                <div
                    className='title'
                    onclick={() => {
                        vnode.attrs.filter.collapsed = !vnode.attrs.filter.collapsed
                    }}
                >
                    <div class='name'>
                        <div class='filter-icon'>
                            <Icon
                                active={active}
                                className='btn-filter-toggle'
                                name={(() => {
                                    if (vnode.attrs.filter.icon) {
                                        return vnode.attrs.filter.icon
                                    }
                                    return vnode.attrs.filter.selection.length ? 'filterRemove' : 'filterPlus'
                                })()}
                                onclick={(e) => {
                                    e.stopPropagation()
                                    clear_filter(vnode.attrs.filter)
                                }}
                                tip={() => {
                                    const filter_title = $t(vnode.attrs.filter.title)
                                    return is_filter_activated(vnode.attrs.filter)
                                        ? $t('filters.actions.deactivate_filter', {name: filter_title})
                                        : $t('filters.inactive_filter', {name: filter_title})
                                }}
                            />
                        </div>
                        {$t(vnode.attrs.filter.title)}
                    </div>
                    <Icon className='btn-collapse' name={vnode.attrs.filter.collapsed ? 'chevronUp' : 'chevronDown'} />
                </div>
                <div class='items'>
                    {is_bounds_signal(vnode.attrs.filter.$selection) && (
                        <Slider
                            infinity={vnode.attrs.filter.infinity}
                            maximum={vnode.attrs.filter.scale[1]}
                            minimum={vnode.attrs.filter.scale[0]}
                            model={vnode.attrs.filter.$selection}
                            step={vnode.attrs.filter.step}
                        />
                    )}
                    {vnode.attrs.filter.help && <div class='help'>{vnode.attrs.filter.help}</div>}
                </div>
            </div>
        )
    }
}
